import {Component} from '@angular/core';

@Component({
  template: `
      <p align="center"><strong>Die Seite ist nicht verfügbar.</strong></p>
      <p></p>
      <p align="center">Bitte Kontaktieren Sie einen Kundenbetreuer.</p>
  `
})
export class NotFoundComponent{}
